import api from "./client";

/** 결제 준비 (TID 발급) — userIdx는 서버가 주문에서 조회 */
export const preparePayment = (
  orderId: string,
): Promise<any> =>
  api
    .post("/v1/payments/prepare", { orderId })
    .then((res) => res.data.data);

/** 결제 수동 승인 */
export const approvePayment = (data: {
  tid: string;
  paymentIdx: number;
  amount: number;
}): Promise<any> =>
  api.post("/v1/payments/approve", data).then((res) => res.data.data);

/** 결제 취소 */
export const cancelPayment = (data: {
  tid: string;
  orderId: string;
  cancelAmt: number;
  reason: string;
}): Promise<any> =>
  api.post("/v1/payments/cancel", data).then((res) => res.data.data);
